import React from "react";
import {AreaChart} from "react-chartkick";
import "chart.js";
import CardHolder from "./CardHolder";

//ColumnChart, LineChart,
//<LineChart xtitle="Time" ytitle="Population" />
//<PieChart donut={true} />
//https://www.npmjs.com/package/react-chartkick

interface CardHeaderProps {
    data: [];
    suffix: string | boolean;
    normalized: boolean;
}

const CardHeader = (props: CardHeaderProps) => {
    const {data, suffix, normalized} = props;
    return (
        <div className={"CardHeader flex flex-row items-between w-full"}>
            {data.map((item, index) => {
                const {color, name, data: data1} = item;
                const data: number[] = Object.values(data1);
                let total: any;
                total = data.reduce((a, b) => +a + +b, 0).toFixed(0);
                if (normalized) total = (total / data.length).toFixed(2);
                return (
                    <div
                        key={index}
                        className="tCardHeaderItem flex-grow text-2xl leading-8 flex flex-col justify-center items-center"
                        style={{
                            color: color,
                        }}
                    >
                        <span className={"text-2xl"}>
                            {total} <b className={"text-base"}>{suffix}</b>
                        </span>
                        <span className={"text-lg capitalize"}>{name}</span>
                    </div>
                );
            })}
        </div>
    );
};
interface TrendCardProps {
    title: string;
    data: [] | any;
    donut?: [];
    suffix: boolean | string;
    legend: boolean | string;
    discrete: boolean;
    center?: string;
    colors?: string[];
    stacked: boolean;
    normalized?: boolean;
}

const TrendCard = (props: TrendCardProps) => (
    <CardHolder title={props.title}>
        <CardHeader data={props.data} normalized={props.normalized || false} suffix={props.suffix || false} />
        <AreaChart
            colors={props.colors || []}
            data={props.data}
            discrete={props.discrete || false}
            legend={props.legend || false}
            stacked={props.stacked || false}
            suffix={props.suffix || false}
        />
    </CardHolder>
);
export default TrendCard;
